import { createBrowserRouter, redirect } from "react-router";
import { createElement } from "react";
import { RootLayout } from "./components/RootLayout";
import { AppLayout } from "./components/AppLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { RouteErrorBoundary } from "./components/RouteErrorBoundary";
import { RouterFehler } from "./components/RouterFehler";
import Dashboard from "./pages/Dashboard";
import ReportEditor from "./pages/ReportEditor";
import Templates from "./pages/Templates";
import Anleitungen from "./pages/Anleitungen";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import TestPage from "./pages/TestPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import VerifyPrompt from "./pages/VerifyPrompt";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import BafaBeraterWerden from "./pages/BafaBeraterWerden";
import Home from "./pages/Home";
import Preise from "./pages/Preise";
import Kontakt from "./pages/Kontakt";
import ESFFillPage from "./pages/ESFFillPage";
import TeamAcceptPage from "./pages/TeamAcceptPage";
import AntragPage from "./pages/AntragPage";
import VnFormPage from "./pages/VnFormPage";
import DataRequestFormPage from "./pages/DataRequestFormPage";
import SigningPage from "./pages/SigningPage";
import GegenzeichnenPage from "./pages/GegenzeichnenPage";
import LoginLinkPage from "./pages/LoginLinkPage";
import KontoauszugVariantenPreview from "./pages/KontoauszugVariantenPreview";
import NotFound from "./pages/NotFound";

export const router = createBrowserRouter([
  {
    Component: RootLayout,
    // Ganz oben, damit KEINE Route mehr auf der Router-Standardseite landet: Die zeigt
    // einen minifizierten Stack und „Hey developer" — für den Berater unbrauchbar, und
    // wir erfahren nichts davon.
    ErrorBoundary: RouterFehler,
    children: [
      {
        path: "/login",
        Component: Login,
      },
      {
        path: "/register",
        Component: Register,
      },
      {
        path: "/forgot-password",
        Component: ForgotPassword,
      },
      {
        path: "/reset-password",
        Component: ResetPassword,
      },
      {
        path: "/verify-email",
        Component: VerifyEmail,
      },
      {
        path: "/verify-prompt",
        Component: VerifyPrompt,
      },
      {
        path: "/formular/:token",
        Component: DataRequestFormPage,
      },
      {
        path: "/unterschreiben/:token",
        Component: SigningPage,
      },
      {
        // Gleiche Seite, nur mit lesbarer Vorgangsnummer im Pfad (kosmetisch —
        // Auth läuft ausschließlich über :token). Neue Mails verlinken hierher,
        // wenn eine Vorgangsnummer bekannt ist; alte Links (nur :token) bleiben
        // über die Route oben weiter gültig.
        path: "/unterschreiben/:vorgangsnummer/:token",
        Component: SigningPage,
      },
      {
        // Gegenzeichnung durch den Berater — Token aus der Benachrichtigungsmail,
        // bewusst ohne Login (am Handy wird fotografiert).
        path: "/gegenzeichnen/:token",
        Component: GegenzeichnenPage,
      },
      {
        path: "/login-link/:token",
        Component: LoginLinkPage,
      },
      {
        path: "/dev/kontoauszug-varianten",
        Component: KontoauszugVariantenPreview,
      },
      {
        path: "/team/accept/:token",
        Component: TeamAcceptPage,
      },
      {
        // Fangnetz fuer unbekannte Pfade (z.B. getippte/geratene URLs): ohne das landet
        // jede falsche Adresse im RouterFehler ("Absturz") statt einer normalen 404-Seite.
        path: "*",
        Component: NotFound,
      },
      {
        Component: AppLayout,
        children: [
          {
            path: "/impressum",
            Component: Impressum,
          },
          {
            path: "/datenschutz",
            Component: Datenschutz,
          },
          {
            path: "/agb",
            Component: AGB,
          },
          {
            path: "/bafa-berater-werden",
            Component: BafaBeraterWerden,
          },
          {
            path: "/home",
            Component: Home,
          },
          {
            path: "/preise",
            Component: Preise,
          },
          {
            path: "/kontakt",
            Component: Kontakt,
          },
        ],
      },
      {
        Component: ProtectedRoute,
        children: [
          {
            path: "/antrag",
            Component: AntragPage,
          },
          {
            path: "/vn-formular",
            Component: VnFormPage,
          },
          {
            Component: AppLayout,
            children: [
              {
                path: "/",
                Component: Dashboard,
              },
              {
                path: "/customers",
                Component: () =>
                  createElement(
                    RouteErrorBoundary,
                    { label: "Customers" },
                    createElement(Customers),
                  ),
              },
              {
                path: "/customers/:id",
                Component: CustomerDetail,
              },
              {
                path: "/reports",
                Component: Reports,
              },
              {
                path: "/editor",
                Component: ReportEditor,
              },
              {
                path: "/editor/:id",
                Component: ReportEditor,
              },
              {
                // Noch nicht im Menü für alle — der Menüpunkt hängt an `isAdmin`, die Route
                // selbst ist bewusst offen: Ein direkter Link soll funktionieren, sobald
                // Inhalte da sind, ohne zweite Baustelle.
                path: "/anleitungen",
                Component: Anleitungen,
              },
              {
                path: "/templates",
                Component: Templates,
              },
              {
                path: "/settings",
                Component: Settings,
              },
              {
                path: "/konto",
                loader: () => redirect("/settings"),
              },
              {
                path: "/admin",
                Component: Admin,
              },
              {
                path: "/test",
                Component: TestPage,
              },
              {
                path: "/esf-ausfuellen",
                Component: ESFFillPage,
              },
            ],
          },
        ],
      },
    ],
  },
]);
